<mat-toolbar class="app-header">
  <button mat-icon-button class="menu-btn" (click)="onMenuClick()" aria-label="Toggle sidebar">
    <mat-icon>menu</mat-icon>
  </button>

  <span class="app-title">{{ pageTitle() }}</span>

  <span class="spacer"></span>

  <button mat-icon-button class="help-btn" aria-label="Help">
    <mat-icon>help_outline</mat-icon>
  </button>

  <div class="profile-wrapper">
    <button mat-icon-button class="avatar-btn" (click)="togglePanel($event)" aria-label="User menu">
      <img src="https://cdn-cloudschool.cssapps.net/images/css-default_profile_picture.png" class="avatar-img" alt="User avatar" />
    </button>

    @if (panelOpen()) {
      <div class="profile-panel" (click)="$event.stopPropagation()">
        <div class="panel-avatar">
          <img src="https://cdn-cloudschool.cssapps.net/images/css-default_profile_picture.png" class="panel-avatar-img" alt="User avatar" />
        </div>
        <div class="panel-name">{{ userName() }}</div>
        <div class="panel-email">{{ userEmail() }}</div>
        <div class="panel-actions">
          <button class="logout-btn" (click)="logout()">LOG OUT</button>
        </div>
      </div>
    }
  </div>
</mat-toolbar>
